import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
function currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kode', 'namabank', 'isbank', 'aktif'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/bankcashacc${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function save(data) {
    return new Promise(async (resolve, reject) => {
        try {
            if (data.frmmode=='add'){
                await axios.post("bankcashacc", data);
            } else {
                await axios.put(`bankcashacc/${encodeURIComponent(data.kode)}`, data);
            }
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.delete(`bankcashacc/${obj.kode}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

export default {
    currency,list, 
    save,
    remove
};